import React, { Fragment } from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Table from '../lib';

import todos from './todos';

const cols = [
  { prop: 'title', label: 'Title' },
  {
    prop: 'done',
    label: 'Status',
    render: prop => (prop ? 'Completed' : 'Pending')
  }
];

const Static = () => (
  <Fragment>
    <Typography variant="title" gutterBottom style={{ color: '#fff' }}>
      Static
    </Typography>

    <Paper square style={{ boxShadow: '8px 8px 0 rgba(0, 0, 0, 0.1)' }}>
      <Table cols={cols} rows={todos} />
    </Paper>

    <Typography
      variant="title"
      gutterBottom
      style={{ marginTop: 40, color: '#fff' }}>
      Static horizontal
    </Typography>

    <Paper square style={{ boxShadow: '8px 8px 0 rgba(0, 0, 0, 0.1)' }}>
      <Table cols={cols} rows={[todos[0]]} horizontal />
    </Paper>
  </Fragment>
);

export default Static;



// WEBPACK FOOTER //
// ./src/examples/Static.js